import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import useTranslation from 'next-translate/useTranslation'
import React from 'react'
import Slider from 'react-slick'

import Caption from '@/components/ui/Typo/Caption'
import Description from '@/components/ui/Typo/Description'
import H2 from '@/components/ui/Typo/H2'
import {
  ImageHostingCarousel1,
  ImageHostingCarousel2,
  ImageHostingCarousel3,
} from '@/res/images'
import { NAMESPACE_HOSTING } from '@/res/namespaces'

const HostingIspManager: React.FC = () => {
  const { t } = useTranslation(NAMESPACE_HOSTING)

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  }

  const items = [
    {
      image: ImageHostingCarousel1.src,
    },
    {
      image: ImageHostingCarousel2.src,
    },
    {
      image: ImageHostingCarousel3.src,
    },
  ]

  return (
    <div className="container mb-20">
      <H2 uppercase={false} weight="font-bold" color="text-primary">
        {t('isp_manager_easy_manage')}
      </H2>

      <div className="tablet:flex justify-between my-4">
        <TextRow
          desc={t('isp_manager_control_panel')}
          text={t('isp_manager_best_manager')}
        />
        <TextRow
          desc={t('isp_manager_ssh_access')}
          text={t('isp_manager_unlimited_ftp_account')}
        />
        <TextRow
          desc={t('isp_manager_personal_accaunt')}
          text={t('isp_manager_manage_hosting')}
        />
      </div>
      <Slider {...settings}>
        {items.map(({ image }, index) => (
          <CarouselCard image={image} key={index} />
        ))}
      </Slider>
    </div>
  )
}

interface ITextRow {
  text: string
  desc: string
}

const TextRow: React.FC<ITextRow> = ({ desc, text }) => {
  return (
    <div className="tablet:w-[calc(33%-18px)]">
      <Description color="text-gray3" weight="font-semibold">
        {desc}
      </Description>
      <Caption color="text-gray3" className="my-4">
        {text}
      </Caption>
    </div>
  )
}

interface ICarousel {
  image: string
}

const CarouselCard: React.FC<ICarousel> = ({ image }) => {
  return (
    <div className="w-full h-auto">
      <img src={image} alt="" />
    </div>
  )
}

export default HostingIspManager
